import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import TinyNodeParkinglocationsModel from './TinyNodeParkinglocationsModel';
import ParkinglocationModel from './ParkinglocationModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/tinynode/tinyNodeInfrastructures';

export default new class TinyNodeInfrastructuresModel {

  constructor() { }

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(tinyNodeParkinglocationId = null) {
    var filter = {};
    if (tinyNodeParkinglocationId) {
      filter = _.merge(filter, { where: { and: [{ parkingLocationId: tinyNodeParkinglocationId }] } });
    }
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          Promise.all([TinyNodeParkinglocationsModel.getAll(), ParkinglocationModel.getAll(true)])
            .then((r) => {
              let tinyNodeParkingLocations = r[0];
              let parkingLocations = r[1];
              let data = [];
              response.data.map(async (child, idx) => {
                let tLocation = _.find(tinyNodeParkingLocations, { id: child.parkingLocationId });
                if (!tLocation || tLocation === undefined) {
                  data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                } else {
                  let location = _.find(parkingLocations, { id: tLocation.parkingLocationID });
                  location
                    ? data.push(Object.assign({}, child, { parkingLocationName: location.Code + ' - ' + location.Name }))
                    : data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                }
              });
              resolve(data);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, Object.assign({}, data, { latitude: 0, longitude: 0 }), {
        // axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  update(id, data) {
    if (data.id !== undefined) {
      delete data.id;
    }
    return new Promise((resolve, reject) => {
      axios.put(BASE + '/' + id, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/TinyNodeInfrastructuresModel.js